import fa from '../JsonLang/fa.json'
export const lang = { ...fa }